import MapQuoter from "./MapQuoter";
import "./map.css";

const MapPage = () => {
  return <MapQuoter />;
};

export default MapPage;
